import React from "react";
import { FaTimes } from "react-icons/fa";
import ConfirmButton from "../common/ConfirmButton";

interface DeclineButtonProps {
    onConfirm: (e?: React.MouseEvent) => void;
    confirmText: string;
    className?: string;
    disabled?: boolean;
}

const DeclineButton = ({ onConfirm, confirmText, className = "", disabled = false }: DeclineButtonProps) => {
    return (
        <ConfirmButton
            className={`min-w-fit px-2 ${className}`}
            content={<FaTimes className="text-red-500 cursor-pointer" />}
            confirmText={confirmText}
            onConfirm={onConfirm}
            disabled={disabled}
        />
    );
};

export default DeclineButton;
